
import React from 'react';
import { Col, Row, message, } from 'antd';
import { MapContainer, Marker, Polygon, LayerGroup, Popup } from "react-leaflet";
import { URL_DASHBOARD } from '../../constants/urls';
import { GET } from '../../frameworks/HttpClient';
import { useParams } from 'react-router-dom';
import { DEFAULT_LOCATION } from '../../constants/string';
import * as _ from 'lodash';
import LayerControl from '../map/layers/LayerControl';
import { MarkerIcon } from '../map/layers/icons/MarkerIcon';


export default function DashBoardMapCC(props) {
  const [dataMap, setDataMap] = React.useState([]);
  const params = useParams();
  const id = (props.id ? props.id : params.id)

  const fetchDataMap = async () => {
    try {
      const response = await GET(`${URL_DASHBOARD.OVERALL_PLANTATION_CC}${id}/`)
      setDataMap(response.data.results)
    } catch (error) {
      message.error(error.errorMessage);
    }
  }

  React.useEffect(() => {
    if (id) {
      fetchDataMap();
    }
  }, []);

  return (
    <Row gutter={16} >
      <Col md={24} sm={24} xs={24} >
        <div style={{ height: "800px", width: "100%" }}>
          <MapContainer zoom={8} maxZoom={20} minZoom={5} center={DEFAULT_LOCATION} attributionControl={false} >
            <LayerControl/>

            {dataMap && dataMap.map((item) => {
              let data = _.get(item, 'polygons.total', []).map((polygon) => {
                return polygon.map((obj) => [obj.latitude, obj.longitude])
              })

              return (
                <LayerGroup>
                  <Polygon positions={data} value={item.id}/>
                </LayerGroup>
              )
            })}
            
            {dataMap.map((item) => {
              return item.location ? (
                <Marker position={[item.location.latitude, item.location.longitude]} icon={MarkerIcon}>
                  <Popup>{[item.code]}<br />{item.sub_district_detail}</Popup>
                </Marker>
              ) : <></>
            })}
          </MapContainer>
        </div>
      </Col>
    </Row>
  )
}